import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { isMobileView } from "../Utility/Utility";

export function useRestorePage() {
  const navigate = useNavigate();

  useEffect(() => {
    if (isMobileView) {
      const isStartUrl = window.location.search.includes("pwa=true");
      if (!isStartUrl) return;

      const last = localStorage.getItem("lastVisited");
      const customerlog =
        localStorage.getItem("customerlog") ||
        sessionStorage.getItem("customerlog");

      // If customer is logged in and no specific last page, default to allproducts
      if (customerlog && (!last || last === "/")) {
        navigate("/kansas_product/allproducts", { replace: true });
        return;
      }

      if (!last || last === "/") return;

      // Prevent infinite loop
      const normalizedPath = window.location.pathname.startsWith("/")
        ? window.location.pathname
        : `/${window.location.pathname}`;
      const normalizedLast = last.startsWith("/") ? last : `/${last}`;

      if (normalizedPath !== normalizedLast) {
        if (normalizedLast.includes("customercartlist")) {
          navigate("/kansas_product/allproducts", { replace: true });
        } else {
          navigate(normalizedLast, { replace: true });
        }
      }
    }
  }, []);
}
